type Props = {
  size: number;
  color?: string;
};

const Electric = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.25 20.25C17.6642 20.25 18 20.5858 18 21C18 21.4142 17.6642 21.75 17.25 21.75H5.25C4.83579 21.75 4.5 21.4142 4.5 21C4.5 20.5858 4.83579 20.25 5.25 20.25H17.25ZM14.9883 5.25C15.7448 5.25 16.3827 5.81381 16.4766 6.56445L16.5 6.75H19.5C20.3284 6.75 21 7.42157 21 8.25V13.5C21 14.3284 20.3284 15 19.5 15H17.5312L17.7891 17.0645C17.9007 17.9595 17.2029 18.75 16.3008 18.75H6.19922L6.03223 18.7412C5.2674 18.6569 4.68785 17.9999 4.69922 17.2305L4.71094 17.0645L5.68359 9.27637L3 5.25H14.9883ZM6.19922 17.25H16.3008L14.9883 6.75H7.51172L6.19922 17.25ZM17.3438 13.5H19.5V8.25H16.6875L17.3438 13.5ZM11.25 3C13.875 3 15.75 4.5 15.75 4.5H6.75C6.75 4.5 8.625 3 11.25 3Z"
        fill={color || '#868686'}
      />
    </svg>
  );
};

export default Electric;
